import { apiClient } from "./api";
import { Tenant } from "../types";

interface ApiOk<T> {
  ok: true;
  data: T;
}

export const tenantService = {
  list: () =>
    apiClient.get<ApiOk<{ tenants: Tenant[] }>>("/v1/tenants/"),

  getById: (tenantId: string) =>
    apiClient.get<ApiOk<Tenant>>(`/v1/tenants/${tenantId}`),

  update: (
    tenantId: string,
    body: Partial<Pick<Tenant, "name" | "wa_phone_number_id" | "wa_verify_token" | "active">>
  ) =>
    apiClient.patch<ApiOk<Tenant>>(`/v1/tenants/${tenantId}`, body),
};
